import { DashboardCard2 } from "@/components/layout/DashboardCard2";
import type { NoteDetail, UUID } from "@/core/types";

import { AccessingPHIDisclaimer } from "./components/AccessingPHIDisclaimer";
import { NoteActions } from "./components/NoteActions";
import { NoteStatusRouter } from "./NoteStatusRouter";

type NoteActionsBarProps = {
  isEditable: boolean;
  isEditing: boolean;
  note: NoteDetail;
  patientId: UUID;
  setDraftNoteId: (id: UUID | null) => void;
  setIsEditing: (v: boolean) => void;
  setShowDeleteNotePopUp: (v: boolean) => void;
};

export function NoteActionsBar({
  isEditable,
  isEditing,
  note,
  patientId,
  setDraftNoteId,
  setIsEditing,
  setShowDeleteNotePopUp,
}: NoteActionsBarProps) {
  return (
    <DashboardCard2 className="tw:flex tw:p-5!" classNameChildren="tw:flex tw:flex-col tw:gap-4">
      <div className="tw:flex tw:flex-row tw:justify-between tw:gap-6">
        <AccessingPHIDisclaimer />

        <NoteActions
          isEditable={isEditable}
          isEditing={isEditing}
          note={note}
          patientId={patientId}
          setDraftNoteId={setDraftNoteId}
          setIsEditing={setIsEditing}
          setShowDeleteNotePopUp={setShowDeleteNotePopUp}
        />
      </div>

      <NoteStatusRouter note={note} />
    </DashboardCard2>
  );
}
